App.SmChosenSuggestionComponent = Em.Component.extend
  classNames: [ 'sm-chosen-suggestion' ]
  classNameBindings: ['isSelected']

  text: (->
    Em.get( @get('item'), @get('labelPath') )
  ).property('item', 'labelPath')


  isSelected: (->
    @get('index') == @get('selectedIndex')
  ).property('index', 'selectedIndex')

  click: ->
    @sendAction('onClick', @get('item'))
